// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"CleanKindEditor--next-sr-only--4jcCU9P","footerButtonsContainer":"CleanKindEditor--footerButtonsContainer--1TY1R-r"};